import { useCallback } from 'react';
import { CreateUserDocument } from 'graphql/generated/graphql';
import type { ILoginFormValues } from 'components/auth/LoginForm';
import type { TAuthArgs } from './useAuthFormSubmit';
import useAuth from './useAuth';

const useSignUp = () => {
  const [signUp] = useAuth(CreateUserDocument);
  // The sign-up form requires both (initial values ''), the mutation types them as required.
  return useCallback(
    ({ email = '', plainPassword = '', ...rest }: TAuthArgs<ILoginFormValues>) =>
      signUp({ ...rest, email, plainPassword }),
    [signUp],
  );
};

export default useSignUp;
